import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL ?? '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ?? '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase環境変数が設定されていません。Supabase機能は無効です。');
}

// Supabase未接続時もアプリがクラッシュしないようダミーURLでクライアントを生成
const resolvedUrl = supabaseUrl || 'https://placeholder.supabase.co';
const resolvedKey = supabaseAnonKey || 'placeholder-anon-key';

export const supabase = createClient(resolvedUrl, resolvedKey);

export interface Post {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  /** スロット名 → { url, alt } のマッピング。DBに jsonb で保存される */
  image_map?: Record<string, { url: string; alt: string }> | null;
  category_slug: string;
  tags: string[];
  featured: boolean;
  image_url: string;
  author_name: string;
  author_avatar?: string;
  published_at: string;
  updated_at: string;
  created_at: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  created_at: string;
}
